'use strict';

angular.module('enervexSalesappApp').controller('HubspotCtrl', function($scope, $stateParams, $timeout, $interval, $uibModal, Account, Auth, Property, Util, HubspotDealsService, _) {
	$scope.jobLabel = Util.jobLabel;
	$scope.accountId = $stateParams.accountId;
	$scope.jobId = $stateParams.jobId;
	$scope.configs = Property.configs();
	$scope.loading = true;
	$scope.forbidden = false;

	/**
	 * Presentation only -- the API enforces canSynchHubspot on every route. This
	 * just gives someone who reaches the URL directly a clear message instead of a
	 * bare error. A function, not a cached value, because the session may not have
	 * resolved when the controller runs.
	 */
	$scope.canSynchHubspot = function() {
		return Auth.hasUserPermissionStrict('canSynchHubspot');
	};
	$scope.syncing = false;
	$scope.error = null;
	$scope.message = null;

	// proposalId -> {checked: bool, version: null|Number, versions: [], amount: Number}
	$scope.selections = {};
	$scope.form = {
		anticipatedCloseDate: null,
		contact: null,
		// these live on the job, not the deal; see fetch() below
		productClass: null,
		hubspotOwner: null
	};
	$scope.productClasses = [];
	$scope.hubspotOwners = [];
	$scope.overrideFields = [];
	// the override controls bind to a map; the job stores an array
	$scope.overrideValues = {};

	/**
	 * The account's HubSpot company, shown read only. There is no picker: the
	 * company belongs to the ACCOUNT, and a per-job choice is what filled the
	 * portal with duplicate companies.
	 */
	$scope.accountCompany = null;
	// contact picker
	$scope.contactSearch = {
		term: '',
		results: [],
		open: false,
		searching: false
	};

	Account.get({
		id: $stateParams.accountId
	}).$promise.then(function(account) {
		$scope.account = account;
	});

	HubspotDealsService.getJob().$promise.then(function(job) {
		$scope.job = job;
		$scope.permissions = Auth.jobPermissions($scope.job, $scope.configs);
	});

	fetch();

	function fetch() {
		HubspotDealsService.getHubspotDeal().$promise.then(function(res) {
			$scope.configured = res.configured;
			$scope.canCreateContact = res.canCreateContact;
			$scope.proposals = res.proposals || [];
			// saved selections whose proposal has since been deleted; their rows
			// cannot be drawn, so the page says so instead of quietly dropping them
			$scope.missingProposals = res.missingProposals || 0;
			// a JOB field that this page edits, not a deal field: saving writes it
			// back onto the job, which is also what the job form sets
			$scope.productClasses = res.productClasses || [];
			$scope.form.productClass = res.productClass || null;
			$scope.hubspotOwners = res.hubspotOwners || [];
			$scope.form.hubspotOwner = res.hubspotOwner || null;
			$scope.overrideFields = res.overrideFields || [];
			$scope.overrideValues = res.overrideValues || {};
			$scope.hubspotDeal = res.hubspotDeal;
			buildSelections();
			$scope.accountCompany = res.accountCompany || null;
			// Nothing saved yet: suggest the contact named in preparedFor. When
			// HubSpot has no match we still prefill the box with the raw text, so
			// the user can create it from there rather than retyping.
			if (!$scope.form.contact) {
				if (res.defaultContact) {
					$scope.form.contact = res.defaultContact;
					$scope.contactSearch.term = contactLabelFor(res.defaultContact);
					$scope.defaultedContact = true;
				} else if (res.defaultContactTerm) {
					$scope.contactSearch.term = res.defaultContactTerm;
					$scope.unmatchedContact = true;
				}
			}
			$scope.loading = false;
			// the sync may have been kicked off from another page, or by a quote
			// edit, so pick up work already in flight on arrival
			watchSyncProgress();
		}).catch(function(err) {
			$scope.loading = false;
			if (err && err.status === 403) {
				$scope.forbidden = true;
				return;
			}
			$scope.error = errorMessage(err);
		});
	}

	// --------------------------------------------------- in-flight sync status

	var progressPoll = null,
		progressPollsLeft = 0;

	// 4s x 45 = 3 minutes, comfortably past the 10s debounce plus a slow push
	var POLL_MS = 4000,
		MAX_POLLS = 45;

	$scope.syncInProgress = function() {
		return $scope.hubspotDeal && $scope.hubspotDeal.syncInProgress && !$scope.hubspotDeal.syncStalled;
	};
	$scope.syncStalled = function() {
		return $scope.hubspotDeal && $scope.hubspotDeal.syncStalled;
	};
	$scope.syncStatusLabel = function() {
		var status = $scope.hubspotDeal && $scope.hubspotDeal.syncStatus;
		if (status === 'pending') {
			return 'A proposal changed. The HubSpot deal will update in a few seconds.';
		}
		if (status === 'syncing') {
			return 'Updating the deal in HubSpot\u2026';
		}
		return '';
	};

	/**
	 * Poll while the server says work is in flight, so the page resolves itself
	 * rather than needing a manual refresh. Stops on completion, on stall, or
	 * once MAX_POLLS is spent.
	 */
	function watchSyncProgress() {
		stopProgressPoll();
		if (!$scope.syncInProgress()) {
			return;
		}
		progressPollsLeft = MAX_POLLS;
		progressPoll = $interval(function() {
			progressPollsLeft = progressPollsLeft - 1;
			if (progressPollsLeft <= 0) {
				stopProgressPoll();
				return;
			}
			HubspotDealsService.getHubspotDeal().$promise.then(function(res) {
				$scope.hubspotDeal = res.hubspotDeal;
				if (!$scope.syncInProgress()) {
					stopProgressPoll();
				}
			}).catch(function() {
				// a blip shouldn't kill the poll; it gives up on its own count
				return null;
			});
		}, POLL_MS);
	}

	function stopProgressPoll() {
		if (progressPoll) {
			$interval.cancel(progressPoll);
			progressPoll = null;
		}
	}

	$scope.$on('$destroy', stopProgressPoll);

	/**
	 * Seed the checkbox / version state from the saved record. Every proposal in
	 * the job gets a row; only the saved ones start checked.
	 */
	function buildSelections() {
		var saved = ($scope.hubspotDeal && $scope.hubspotDeal.proposals) || [];
		$scope.selections = {};
		_.each($scope.proposals, function(proposal) {
			var match = _.find(saved, function(row) {
				var id = (row.proposal && row.proposal._id) ? row.proposal._id : row.proposal;
				return '' + id === '' + proposal._id;
			});
			$scope.selections[proposal._id] = {
				checked: match ? true : false,
				// null == "(latest version)"
				version: match ? match.version : null,
				// versions are sequential integers, so 1..current is the full list
				versions: versionList(proposal),
				// the server priced the latest version; a pinned one is fetched below
				amount: proposal.amount,
				pricing: false
			};
			if (match && match.version) {
				refreshAmount(proposal._id);
			}
		});
		if ($scope.hubspotDeal) {
			$scope.form.anticipatedCloseDate = $scope.hubspotDeal.anticipatedCloseDate ?
				new Date($scope.hubspotDeal.anticipatedCloseDate) : null;
			if ($scope.hubspotDeal.hubspotContactId) {
				$scope.form.contact = {
					id: $scope.hubspotDeal.hubspotContactId,
					name: $scope.hubspotDeal.hubspotContactName
				};
				$scope.contactSearch.term = $scope.hubspotDeal.hubspotContactName;
			}
		}
	}

	function versionList(proposal) {
		var versions = [];
		for (var i = proposal.version || 1; i >= 1; i--) {
			versions.push(i);
		}
		return versions;
	}

	$scope.anySelected = function() {
		return _.some(_.values($scope.selections), function(selection) {
			return selection.checked;
		});
	};

	/**
	 * Running total of the checked proposals, so the number pushed to HubSpot is
	 * visible before syncing rather than only afterwards.
	 */
	$scope.selectedTotal = function() {
		var total = 0;
		_.each($scope.selections, function(selection) {
			if (selection && selection.checked) {
				total = total + (selection.amount || 0);
			}
		});
		return total;
	};

	/**
	 * Price a row at the version it is pinned to. A proposal's total lives on the
	 * quote VERSION it was built from, so only the server can read it -- the page
	 * showing the latest total next to a v2 selection would promise an amount the
	 * sync is never going to push.
	 */
	function refreshAmount(proposalId) {
		var selection = $scope.selections[proposalId];
		if (!selection) {
			return;
		}
		selection.pricing = true;
		HubspotDealsService.proposalAmount(proposalId, selection.version).$promise.then(function(res) {
			// a later change may have landed while this was in flight
			if (selection.version === res.version) {
				selection.amount = res.amount;
			}
			selection.pricing = false;
		}).catch(function() {
			selection.pricing = false;
			return null;
		});
	}

	$scope.change = function() {
		$scope.dirty = true;
	};

	/**
	 * The version dropdown moved: re-price that row.
	 */
	$scope.versionChanged = function(proposalId) {
		$scope.dirty = true;
		refreshAmount(proposalId);
	};

	// ------------------------------------------------------------ contact picker

	function contactLabelFor(contact) {
		return _.compact([contact.name, contact.email]).join(' - ');
	}
	$scope.contactLabel = contactLabelFor;

	var contactTimer = null;
	$scope.onContactTermChanged = function() {
		$scope.form.contact = null;
		$scope.defaultedContact = false;
		$scope.unmatchedContact = false;
		$scope.dirty = true;
		if (contactTimer) {
			$timeout.cancel(contactTimer);
		}
		var term = $scope.contactSearch.term;
		if (!term || term.length < 2) {
			$scope.contactSearch.results = [];
			$scope.contactSearch.open = false;
			return;
		}
		// same 5 req/sec portal limit as the company search
		contactTimer = $timeout(function() {
			$scope.contactSearch.searching = true;
			HubspotDealsService.searchContacts(term).$promise.then(function(results) {
				$scope.contactSearch.results = results;
				$scope.contactSearch.open = true;
				$scope.contactSearch.searching = false;
			}).catch(function(err) {
				$scope.contactSearch.searching = false;
				$scope.error = errorMessage(err);
			});
		}, 350);
	};

	$scope.pickContact = function(contact) {
		$scope.form.contact = contact;
		$scope.contactSearch.term = contactLabelFor(contact);
		$scope.contactSearch.open = false;
		$scope.defaultedContact = false;
		$scope.unmatchedContact = false;
		$scope.dirty = true;
	};

	$scope.clearContact = function() {
		$scope.form.contact = null;
		$scope.contactSearch.term = '';
		$scope.contactSearch.results = [];
		$scope.contactSearch.open = false;
		$scope.defaultedContact = false;
		$scope.unmatchedContact = false;
		$scope.dirty = true;
	};

	// ------------------------------------------------------------ create modals

	function openRecordModal(kind, prefill) {
		return $uibModal.open({
			templateUrl: 'app/main/hubspot/hubspot-record-modal.html',
			controller: 'HubspotRecordModalCtrl',
			size: 'sm',
			resolve: {
				kind: function() {
					return kind;
				},
				prefill: function() {
					return prefill;
				}
			}
		}).result;
	}

	$scope.createContact = function() {
		openRecordModal('contact', $scope.contactSearch.term).then(function(contact) {
			$scope.pickContact(contact);
		}).catch(function() {
			return null;
		});
	};

	// ------------------------------------------------------------------- actions

	function payload(skipAutoSync) {
		var proposals = [];
		_.each($scope.proposals, function(proposal) {
			var selection = $scope.selections[proposal._id];
			if (selection && selection.checked) {
				proposals.push({
					proposal: proposal._id,
					version: selection.version
				});
			}
		});
		return {
			proposals: proposals,
			// an explicit sync follows immediately, so don't also queue a debounced
			// one: it would only flash a misleading "Queued" badge and then no-op
			skipAutoSync: skipAutoSync ? true : false,
			// no company here: the server derives it from the job's account
			hubspotContactId: $scope.form.contact ? $scope.form.contact.id : null,
			hubspotContactName: $scope.form.contact ? $scope.form.contact.name : null,
			anticipatedCloseDate: $scope.form.anticipatedCloseDate,
			// all written back onto the JOB by the server, not stored on the deal
			productClass: $scope.form.productClass || "",
			hubspotOwner: $scope.form.hubspotOwner || "",
			hubspotOverrides: $scope.overrideValues || {}
		};
	}

	$scope.save = function(skipAutoSync) {
		$scope.error = null;
		$scope.message = null;
		return HubspotDealsService.saveHubspotDeal(payload(skipAutoSync)).$promise.then(function(res) {
			$scope.hubspotDeal = res;
			$scope.dirty = false;
			$scope.message = 'Saved.';
			return res;
		}).catch(function(err) {
			$scope.error = errorMessage(err);
			throw err;
		});
	};

	/**
	 * The everyday action: save what is on screen, then push. This is what creates
	 * the deal the first time -- saving alone never leaves HubSpot out of date.
	 */
	$scope.saveAndSync = function() {
		$scope.error = null;
		$scope.message = null;
		$scope.syncing = true;
		$scope.save(true).then(function() {
			return HubspotDealsService.sync().$promise;
		}).then(function(res) {
			$scope.hubspotDeal = res;
			$scope.syncing = false;
			$scope.message = 'Saved and synced to HubSpot.';
			buildSelections();
			watchSyncProgress();
		}).catch(function(err) {
			$scope.syncing = false;
			$scope.error = errorMessage(err);
		});
	};

	/**
	 * Push the stored record again without saving the form. Useful after a failed
	 * sync, or to overwrite an edit someone made on the HubSpot side.
	 */
	$scope.resync = function() {
		$scope.error = null;
		$scope.message = null;
		$scope.syncing = true;
		HubspotDealsService.sync().$promise.then(function(res) {
			$scope.hubspotDeal = res;
			$scope.syncing = false;
			$scope.message = 'Re-synced to HubSpot.';
			buildSelections();
			watchSyncProgress();
		}).catch(function(err) {
			$scope.syncing = false;
			$scope.error = errorMessage(err);
		});
	};

	/**
	 * Checked rows the server could not price, by name. A proposal can outlive the
	 * quote it was built from, and then there is no total to push -- better to say
	 * so here than to let the sync come back with an error. Rows still being
	 * priced are not counted, or the warning would flash on every version change.
	 */
	$scope.unpricedSelected = function() {
		var names = [];
		_.each($scope.proposals, function(proposal) {
			var selection = $scope.selections[proposal._id];
			if (selection && selection.checked && !selection.pricing && selection.amount == null) {
				names.push(proposal.name || 'a proposal');
			}
		});
		return names;
	};

	$scope.canSaveAndSync = function() {
		if (!$scope.configured || !$scope.accountCompany || !$scope.anySelected() || $scope.syncing) {
			return false;
		}
		// nothing to total means nothing to push, and pushing the 0 that would come
		// out of it would wipe the amount on a live deal
		return $scope.unpricedSelected().length === 0;
	};

	/**
	 * Re-synch only makes sense once the deal exists in HubSpot.
	 */
	$scope.canResync = function() {
		return ($scope.configured && $scope.hubspotDeal && $scope.hubspotDeal.hubspotDealId && !$scope.syncing) ? true : false;
	};

	function errorMessage(err) {
		var message = (err && err.data && err.data.message) ? err.data.message : null;
		if (!message && err && err.statusText) {
			message = err.statusText;
		}
		return message || 'Something went wrong talking to HubSpot.';
	}
});
